<h3>CALL FOR PAPERS</h3>

<h5>TOPICS</h5>
<p>
    All topic areas related to cryptography are of interest and in scope.
</p>
<p>
    Suggested topics include but are not restricted to:
</p>
<ul style="list-style-type: none">
    <li> Anonymity and Privacy </li>
    <li> Applied Cryptography and Implementations </li>
    <li>Authentication, Identification and Access Control</li>
    <li>Boolean Functions and Discrete Mathematics</li>
    <li>Complexity-Theoretic Cryptography</li>
    <li>Cryptanalysis</li>
    <li>Cryptocurrencies and Blockchain</li>
    <li>Cryptographic Hash Functions</li>
    <li>Cryptographic Protocols</li>
    <li>Digital Signatures and Message Authentication Codes</li>
    <li>Distributed Systems Security</li>
    <li>Elliptic-Curve Cryptography</li>
    <li>Formal Security Methods</li>
    <li>Information-Theoretic Security</li>
    <li>Post-Quantum Cryptography</li>
    <li>Public-Key Encryption</li>
    <li>Physical Cryptography</li>
    <li>Secure Multiparty Computation</li>
    <li>Symmetric Cryptography</li>
    <li>Zero-Knowledge Proofs</li>
</ul>
<h5> SUBMISSIONS AND PROCEEDINGS </h5>
<p>
    The Proceedings of the conference will be published on <em>Collectio Ciphrarum - Proceedings
        of cryptographic conferences and workshops</em> (Aracne, Rome) in two different forms,
    according to the criteria specified below.
</p>
<p> Authors who wish to give a talk should prepare an extended abstract of their work
    consisting of at least 5 pages and no more than 30 pages. Only previously unpublished
    contributions are considered.
</p>
<p> After the review round, the accepted papers are divided in two categories:</p>
<ul>
    <li> regular papers, </li>
    <li> selected papers. </li>
</ul>
<p>
    Authors of regular papers are required to submit a revised version of their paper,
    meeting the style and page requirements that will be set by the Scientific Committee
</p>
<p>
    Authors whose paper has been accepted as "selected” can apply for inclusion in a special
    issue of <a href="https://www.degruyter.com/journal/key/jmc/html"> <em> Journal of Mathematical Cryptology </em></a>
    (De Gruyter).
    The journal will further select which papers will be published (in revised form).
    These papers will be published in Open Access and will be free of any charge for the authors.
    Moreover, the authors of the journal papers will be required to provide a two-page abstract to appear
    in the Proceedings.
</p>
<p>
    The reviews of submissions are performed by the Programme Committee,
    under the guidance of the two Chairs.
</p>
<h5> IMPORTANT DATES </h5>
<ul style="list-style-type: none">
    <li> Submission deadline: 10 June, 2023</li>
    <li> Notification to authors: 31 July, 2023 (conference) - 12 September 2023 (journal)</li>
    <li> Camera-Ready Version due: 9 October, 2023</li>
    <li> Conference dates: 14th and 15th December, 2023</li>

</ul>
<h5> INSTRUCTIONS FOR AUTHORS</h5>
<ul>
    <li>Electronic submission of non-anonymous papers via EasyChair.</li>
    <li>Papers must be typeset using LaTeX in the <a
            href="https://www.overleaf.com/latex/templates/springer-lecture-notes-in-computer-science/kzwwpvhwnvfj">LNCS</a>
        style.</li>
    <li>We encourage authors to typeset the paper using Springer's LNCS LaTeX package with no changes to the style.
        Paper's length should range from 5 to 30 pages, excluding references and clearly marked appendices.
        Programme Committee members are not required to read appendices, so the paper should be intelligible without
        them.</li>
    <li>Papers must be written in English, and begin with a title, a short abstract, and a list of keywords.
        An introduction section should summarize the paper's contributions at a level appropriate for a non-specialist
        reader.</li>
    <li>Submissions must be in PDF format.</li>
    <li>Upon acceptance, the authors will revise their papers and change the Latex style according to the publication
        medium.</li>
</ul>
<h5> PRESENTATION </h5>
<p>Authors of accepted papers must guarantee that their paper will be presented at the conference.</p>
<br>
<hr>
<h3> SUBMISSION </h3>

<p>
	Conference contributions can be submitted via EasyChair
	using the following <a href="https://easychair.org/conferences/?conf=cifris23" target="_blank">link</a>.
</p>